import { format } from 'date-fns';
import { useHistory } from 'react-router-dom';
import { ACTIVITY_SESSION_TYPE_KOR } from 'src/constants/activityv3.enum';
import { ResponseActivityV3SessionByStudentDto } from 'src/generated/model';
import { BadgeV2 } from '../common/BadgeV2';
import { Typography } from '../common/Typography';
import SVGIcon from '../icon/SVGIcon';

interface ActivitySessionCardProps {
  activitySession: ResponseActivityV3SessionByStudentDto;
  isSubmitted: boolean;
  type?: 'list' | 'detail' | 'todo';
  id: number;
  isEnded: boolean;
}

export function ActivitySessionCard({
  activitySession,
  isSubmitted,
  isEnded,
  type = 'list',
  id,
}: ActivitySessionCardProps) {
  const { push } = useHistory();
  const submittedAt = activitySession.studentActivitySessions?.[0]?.submittedAt;
  const isLateSubmission =
    submittedAt && activitySession.endDate && new Date(activitySession.endDate) < new Date(submittedAt);

  return (
    <div
      key={activitySession.id}
      className={`flex cursor-pointer flex-row items-center justify-between gap-2 rounded-xl p-4 ${
        type === 'list'
          ? 'bg-primary-gray-50'
          : type === 'detail'
            ? 'border border-primary-gray-200 bg-white shadow-[0_4px_8px_0_#F4F6F8]'
            : 'bg-white'
      }`}
      onClick={() => push(`/student/activity/${id}/session/${activitySession.id}`)}
    >
      <section className="flex flex-col gap-2">
        <nav className="flex flex-row items-center gap-1">
          {activitySession.type !== 'NOTICE' && (
            <BadgeV2 type="solid_strong" color={isEnded ? 'gray' : 'orange'} size={20}>
              {activitySession.activitySessionOrder?.viewOrder}
            </BadgeV2>
          )}
          <BadgeV2
            type="solid_strong"
            color={
              activitySession.type === 'SURVEY' ? 'brown' : activitySession.type === 'POST' ? 'navy' : 'dark_green'
            }
            size={20}
          >
            {ACTIVITY_SESSION_TYPE_KOR[activitySession.type]}
          </BadgeV2>
          {activitySession.type !== 'NOTICE' && (
            <>
              <BadgeV2 type="solid_regular" color={isEnded ? 'navy' : 'orange'} size={20}>
                {isEnded ? '종료' : '진행중'}
              </BadgeV2>
              <BadgeV2 type="line" color={!isSubmitted ? 'red' : isLateSubmission ? 'orange' : 'green'} size={20}>
                {!isSubmitted ? '미제출' : isLateSubmission ? '지각제출' : '제출완료'}
              </BadgeV2>
            </>
          )}
        </nav>
        <div className="flex flex-col gap-0.5">
          <Typography variant="body2" className="font-medium">
            {activitySession.title}
          </Typography>
          {activitySession.endDate && (
            <>
              {isEnded && activitySession.isLateSubmissionAllowed && activitySession.lateSubmissionEndAt ? (
                <Typography variant="caption2" className="font-medium text-primary-gray-500">
                  지각 제출 : {format(new Date(activitySession.lateSubmissionEndAt), 'yyyy.MM.dd HH:mm')}&nbsp;까지
                </Typography>
              ) : (
                <Typography variant="caption2" className="font-medium text-primary-gray-500">
                  {format(new Date(activitySession.endDate), 'yyyy.MM.dd')}&nbsp;까지
                </Typography>
              )}
            </>
          )}
        </div>
      </section>
      <SVGIcon.Arrow color="gray700" size={16} rotate={180} weight="bold" />
    </div>
  );
}
